import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Button } from "@fluentui/react-northstar";
import { Modal } from "../../interfaces/Modal";
import React, { useCallback } from "react";
import { setModalWithData } from "../../redux/reducers/ModalReducer/ModalReducer";
import { useDispatch } from "react-redux";
import { useNewsCache } from "../../hook/useNewsCache";
import { useLocation } from "react-router-dom";
import { useAppConfigurationSelector } from "../../redux/reducers/AppConfigurationReducer/AppConfigurationReducer";
import { convertFromToAppType } from "../InformationMenu/InformationMenu.utils";
export const CampaignButton = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const isNotInsideRestrictedRoutes = !location.pathname.includes("/remove") && !location.pathname.includes("/configuration") && !location.pathname.includes("/widget");
    const { from } = useAppConfigurationSelector("from");
    const { queryNews } = useNewsCache({ appType: convertFromToAppType(from) });
    const openNewsDialog = useCallback(() => {
        dispatch(setModalWithData({ isOpen: Modal.NEWS, data: { skipLocalStorage: true } }));
    }, []);
    if (!isNotInsideRestrictedRoutes)
        return;
    if (!queryNews.data)
        return;
    if (queryNews.data.length === 0)
        return;
    if (!queryNews?.data[0]?.navbarCtaLabel)
        return;
    return (_jsx(Button, { "data-testid": "navbar-bf-btn", primary: true, styles: { minWidth: "auto" }, content: _jsx(Text, { content: queryNews.data[0].navbarCtaLabel }), onClick: openNewsDialog }));
};
